import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Contact } from '@hdms/shared/common-types';

@Component({
  selector: 'shrd-pf-ui-header-user-name',
  templateUrl: './header-user-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserNameComponent {
  @Input() user: Contact;
  @Input() omitTitle = false;
}
